import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Iteration } from '@/api/model/interfaces';

export default class PackageKS2IterationOdata extends OdataManager<PackageKS2Iteration> {}
